import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { Colors, Typography } from '../../shared/theme/styles.enum';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleContainer: {
      margin: '65px 65px 35px 65px',
      display: 'flex',
      justifyContent: 'space-between',
      '@media (max-width:768px)': {
        margin: '24px 16px 20px 16px',
        flexDirection: 'column',
        gap: 16,
      },
    },
    title: {
      fontFamily: Typography.FontFamily1,
      fontSize: Typography.H4,
      fontWeight: 600,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 0.83,
      letterSpacing: 'normal',
      textAlign: 'left',
      color: theme.palette.primary.main,
    },
    buttonReset: {
      padding: '8px 15px 7px',
      borderRadius: 3,
      border: 'solid 1px',
      borderColor: theme.palette.primary.main,
      fontFamily: Typography.FontFamily2,
      fontSize: Typography.Body,
      fontWeight: 600,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      textAlign: 'center',
      color: theme.palette.primary.main,
    },
    stepperBox: {
      margin: '30px 55px 80px 55px',
      borderRadius: 14,
      boxShadow: '0 2px 16px rgba(0, 0, 0, 0.08)',
      backgroundColor: Colors.White,
      '& .MuiSvgIcon-root': {
        width: '34px',
        height: '34px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },

      '& .MuiStepIcon-text': {
        fill: Colors.White,
        fontSize: Typography.Footnotes,
        fontFamily: Typography.FontFamily2,
        fontWeight: 500,
      },
      '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
        marginTop: '16px',
        textAlign: 'center',
        fontSize: Typography.Body,
        fontFamily: Typography.FontFamily2,
      },
      '@media (max-width:768px)': {
        margin: '16px 0 40px 0',
        borderRadius: 8,
        overflow: 'hidden',
        '& .MuiStepper-root': {
          padding: '16px 0',
        },
        '& .MuiStep-root': {
          padding: '0 2px',
        },
        '& .MuiSvgIcon-root': {
          width: '26px',
          height: '26px',
        },
        '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
          fontSize: '0.65rem',
          marginTop: '6px',
        },
      },
    },
    container: {
      padding: '25px 55px 25px 55px',
      '@media (max-width:768px)': {
        padding: '16px 16px',
      },
    },
    content: {
      margin: '20px 0 50px 0',
    },
    buttonsContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '0 0 30px',
      '$ .Mui-disabled': {
        display: 'hidden',
      },
      '& .MuiButton-contained.Mui-disabled': {
        color: Colors.White,
        backgroundColor: theme.palette.primary.main,
        opacity: 0.5,
      },
    },
    buttonBack: {
      borderColor: theme.palette.primary.main,
      borderRadius: 8,
      width: 126,
      height: 42,
      color: theme.palette.primary.main,
      fontSize: Typography.Body,
      fontFamily: Typography.FontFamily2,
      fontWeight: 600,
    },
    buttonNext: {
      borderColor: theme.palette.primary.main,
      borderRadius: 8,
      width: 126,
      height: 42,
      color: Colors.White,
      fontSize: Typography.Body,
      fontFamily: Typography.FontFamily2,
      fontWeight: 600,
    },
    buttonHidden: {
      visibility: 'hidden',
    },
  })
);
